export enum Region {
  SINGAPORE = 'SINGAPORE',
  NORTH_AMERICA = 'NORTH_AMERICA',
  HONG_KONG = 'HONG_KONG',
}
